import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Calendar, MeetingType } from '@vendasta/meetings';
import { GroupMeetingType } from '../../data-providers/meeting-scheduler-store.service';

@Injectable({
  providedIn: 'root',
})
export class MeetingListSharedDataService {
  personalCalendar: Calendar;
  groupGeneralCalendar: Calendar[];
  personalMeetingTypes: MeetingType[];
  groupMeetingTypes: { [calendarId: string]: GroupMeetingType[] };

  setPersonalDefaultCalendar(personalCalendar$: Observable<Calendar>) {
    personalCalendar$.subscribe((value) => (this.personalCalendar = value));
  }

  getPersonalDefaultCalendar() {
    return this.personalCalendar;
  }
  setGroupCalendar(groupCalendarLink$: Observable<Calendar[]>) {
    groupCalendarLink$.subscribe((value) => {
      this.groupGeneralCalendar = value;
    });
  }

  getGroupCalendar() {
    return this.groupGeneralCalendar;
  }

  setPersonalMeetingTypes(personalMeetingTypes$: Observable<MeetingType[]>) {
    personalMeetingTypes$.subscribe((value) => (this.personalMeetingTypes = value));
  }

  getPersonalMeetingTypes() {
    return this.personalMeetingTypes;
  }

  setGroupMeetingTypes(groupMeetingTypes$: Observable<{ [calendarId: string]: GroupMeetingType[] }>) {
    groupMeetingTypes$.subscribe((value) => (this.groupMeetingTypes = value));
  }

  getGroupMeetingTypes() {
    return this.groupMeetingTypes;
  }
}
